import { QuickOrganization } from "./QuickOrganization";

const QuickDirectory = ({ activeTab }) => {
  if (activeTab !== "organization") return null;

  return (
    <div className="!text-[12px] ml-[10px]">
      <div className="py-[10px]">
        <QuickOrganization onlyView={true} />
      </div>
    </div>
  );
};

export { QuickDirectory };
